import styled from '@emotion/styled';
import MessageWrapperBase from './MessageWrapperBase';
import { FormattedMessage } from 'react-intl';

const MessageWrapper = styled(MessageWrapperBase)({
  paddingTop: 24,
  paddingBottom: 24,
  textAlign: 'center',
});

const EmptyFolderMessage = () => (
  <MessageWrapper>
    <p>
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.messages.empty_folder" />
    </p>
  </MessageWrapper>
);

export default EmptyFolderMessage;
